import { render } from "./indexpage.vue?vue&type=template&id=17d7f2f4&scoped=true"
import script from "./indexpage.vue?vue&type=script&lang=js"
export * from "./indexpage.vue?vue&type=script&lang=js"

import "./indexpage.vue?vue&type=style&index=0&id=17d7f2f4&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d7f2f4"]])

export default __exports__